<template>
  <div class="apply_electronic">
    <el-container>
      <el-header style="height: 100px">
        <Head></Head>
      </el-header>
      <el-main class="security_main_body">
        <div class="security_main_body_div">
          <div class="security_main_body_div_H1">网站测试</div>
          <div class="security_main_body_div_text">
            帮助您优化网站性能，提升速度和稳定性，同时采取有效的安全措施，防范各类网络攻击，确保用户数据和隐私的安全
          </div>
          <div class="security_main_body_div_butts">
            <div class="security_main_body_div_butt div_buttA" @click="loginshow">免费试用</div>
            <div class="security_main_body_div_butt div_buttB" @click="topay">产品价格</div>
          </div>
          <div class="apply_electronic_dzsw_d4">
            <div>
              <img
                src="http://apiupss.ppfly.top/images/banner_icon1.svg"
                alt=""
              />
              <div>全球220+地区</div>
            </div>
            <div>
              <img
                src="http://apiupss.ppfly.top/images/banner_icon7.svg"
                alt=""
              />
              <div>真实家庭住宅</div>
            </div>
            <div>
              <img
                src="http://apiupss.ppfly.top/images/banner_icon3.svg"
                alt=""
              />
              <div>定位国家/州/城市IP</div>
            </div>
            <div>
              <img
              style="width: 60px;"
                src="http://apiupss.ppfly.top/images/banner_icon6.png"
                alt=""
              />
              <div>HTTP(S)/Socks5协议</div>
            </div>
          </div>
        </div>

        <div class="security_main_body_divB">
          <div class="security_main_body_divB_div">
            <div class="security_main_body_divB_div_left">
              <div>
                <div class="security_main_body_divB_div_left_H1">
                  全面测试网站性能
                </div>
                <div class="security_main_body_divB_div_left_text">
                  获取全面的网站性能数据，提升网站竞争力
                </div>
              </div>
              <div>
                <div class="applyele_list_img">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/tip_icon2.svg"
                      alt=""
                    />
                  </div>
                  <div>
                    <div>测试网络负载平衡</div>
                    <div class="applyele_list_img_text">
                      实时监控网站运行情况，确保网站在不同地区和网络环境下稳定高效运行
                    </div>
                  </div>
                </div>
                <div class="applyele_list_img">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/tip_icon2.svg"
                      alt=""
                    />
                  </div>
                  <div>
                    <div>提升用户体验</div>
                    <div class="applyele_list_img_text">
                      精准模拟全球用户访问情况，了解不同地区用户的访问体验，优化用户界面和加载速度
                    </div>
                  </div>
                </div>
                <div class="applyele_list_img">
                  <div>
                    <img
                      src="http://apiupss.ppfly.top/images/tip_icon2.svg"
                      alt=""
                    />
                  </div>
                  <div>
                    <div>巩固安全防御</div>
                    <div class="applyele_list_img_text">
                      全方位评估您的网站的安全性，免受恶意攻击和数据泄露的威胁，提升网站的安全防护能力
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="security_main_body_divB_div_reft">
              <img
                src="http://apiupss.ppfly.top/images/introduce_r_6.svg"
                alt=""
              />
            </div>
          </div>
        </div>

        <apply_electronic_mainket />
        <Footer></Footer>
      </el-main>
    </el-container>
    <Xuanfuret></Xuanfuret>
  </div>
</template>
<script>
import Head from "@/components/head/head.vue";
import Footer from "@/components/footer/footer.vue";
import Xuanfuret from "@/components/xuanfuret/xuanfuret.vue";
import apply_electronic_mainket from "@/components/apply_electronic_mainket/apply_electronic_mainket.vue";
export default {
  // apply-market
  name: "apply_test",
  components: {
    Head,
    Footer,
    Xuanfuret,
    apply_electronic_mainket,
  },
  data() {
    return {};
  },
  methods: {
    totop() {
      // 滚动到顶部的逻辑
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    topay(){
      this.$router
          .push({
            path: "/pay",
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
        this.$router.go(0);
    },
    loginshow() {
      const token = this.$cookies.get("userdata");
      if (token == null) {
        this.$router
          .push({
            path: "/userlogin",
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              // 处理其他错误
              console.error(err);
            }
          });
      }
    },
  },

  created() {

  },
  mounted() {
    this.totop()
  },
};
</script>
<style lang="scss" scoped>
.security_main_body{
  background-color: #f5f2f23a;
}
.security_main_body_div {
  background: url(http://apiupss.ppfly.top/images/buy-banner.bb39d3b.png);
  background-color: #edf3fc;
  background-repeat: no-repeat;
  padding-bottom: 50px;
  // https://oss.kookeey.com/keekooy-next-dist/public/_nuxt/proxy-network_bg.1d9685a0.png
}
.security_main_body_div_H1 {
  padding-top: 80px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  font-size: 54px;
  color: #1b2336;
  line-height: 76px;
}
.security_main_body_div_text {
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 22px;
  color: rgba(18, 17, 39, 0.72);
  line-height: 40px;
  max-width: 865px;
  margin: 31px auto 0;
}
.apply_electronic_dzsw_d4 {
  width: 60%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.apply_electronic_dzsw_d4  img{
  margin-bottom: 30px;
}
.security_main_body_div_butts {
  display: flex;
  justify-content: center;
  margin: 80px 0 80px 0;
}

.security_main_body_div_butt {
  width: 191px;
  height: 54px;
  border-radius: 45px;
  font-family: SourceHanSansCN-Medium;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  cursor: pointer;
  box-sizing: border-box;
}
.div_buttA {
  background: #3580ff;
  color: #edf3fc;
}
.div_buttB {
  background: transparent;
  border: 1px solid #0e1d3c;
  color: #0e1d3c;
}
.security_main_body_divB {
  margin-top: 200px;
}
.security_main_body_divB_div {
  width: 70%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 0 0 0 60px;
  background-color: #edf3fc;
  border-radius: 10px;
}
.security_main_body_divB_div_left {
  width: 50%;
  padding-top: 75px;
}
.security_main_body_divB_div_reft {
  width: 50%;
  margin-top: 60px;
}
.security_main_body_divB_div_left_H1 {
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  font-size: 36px;
  color: #1b2336;
  line-height: 40px;
  text-align: left;
}
.security_main_body_divB_div_left_text {
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #565656;
  line-height: 26px;
  margin-top: 34px;
  margin-bottom: 24px;
  text-align: left;
}
.applyele_list_img {
  display: flex;
  justify-content: left;
  margin: 10px 0 10px 0;
}
.applyele_list_img > div {
  text-align: left;
  margin-right: 20px;
}
.applyele_list_img > div:nth-child(1) {
  text-align: left;
  margin-top: 7px;
}
.applyele_list_img_text {
  font-weight: 400;
  font-size: 14px;
  color: #565656;
  margin-top: 5px;
}
</style>
